import { render, staticRenderFns } from "./NavigationOriginPopup.vue?vue&type=template&id=3579e3cf&scoped=true&"
import script from "./NavigationOriginPopup.vue?vue&type=script&lang=js&"
export * from "./NavigationOriginPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3579e3cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3579e3cf')) {
      api.createRecord('3579e3cf', component.options)
    } else {
      api.reload('3579e3cf', component.options)
    }
    module.hot.accept("./NavigationOriginPopup.vue?vue&type=template&id=3579e3cf&scoped=true&", function () {
      api.rerender('3579e3cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/NavigationOriginPopup.vue"
export default component.exports